<template>
  <ReferenceHandler @entryClicked="entryClicked">
    <span v-if="!icon" class="crossref" :data-to="to"><slot/></span>
    <v-icon v-else class="mx-1 crossref notDotted" :style="$vuetify.breakpoint.xsOnly ? 'font-size: 20px' : ''" :color="$finColors.accentRed" :data-to="to"> {{ icon }}</v-icon>
  </ReferenceHandler>
</template>
<script>
import {EventBus} from '@/plugins/fincraft'
import ReferenceHandler from "@/components/common/lexicon/LexiconOverlay/ReferenceHandler"

export default {
  name: "FinLexiconLink",
  components: {ReferenceHandler},
  props: {
    to: {
      type: String
    },
    onlyEntry: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
    },
  },
  methods: {
    entryClicked(entry) {
      EventBus.$emit('showLexicon', entry?.ref, this.onlyEntry)
    },
  }
}
</script>

<style scoped lang="scss">
.notDotted {
  border-bottom: unset;
}
</style>
